<template>
	<header>
		<div class="header-logo">
			<div class="header-logonav">
				<div class="top-logo">
					<img src="../../static/img/logo2.png"/>
				</div>
				<div class="top-other">
					<span><p>设为主页   &nbsp;&nbsp;|&nbsp;&nbsp;  收藏本页</p></span>
					<span>
						<a rel="nofollow" title=" 客服热线：0752-2123600" target="_blank"><img src="../../static/img/icon1.png"/></a>
						<a rel="nofollow" href="http://wpa.qq.com/msgrd?v=3&uin=3250932395&site=qq&menu=yes" title="QQ：3250932395" target="_blank"><img src="../../static/img/icon2.png"/></a>
						<img src="../../static/img/log-sys.png"/>
						<a href="http://oa.gd-sc.net:8080/obpm/">进入业务系统</a></span>
				</div>
			</div>
		</div>
		<div class="header-o" :style="{background : '#0066ef' ,opacity : 1}">
			
		</div>
			<div class="nav-nav">
				<ul>
					<li v-for="(na , index) in nav" v-bind:class="{liactive: acli == na.id}"  id="index" @mouseenter="slide(index)" @mouseleave="out()" >
						
							<router-link :to= 'na.linkto'  :style="{color : '#fff' }" v-bind:class="{liaactive: acli == na.id} "> 
								<div class="gogogo"  @click="linkto(na.id)">
								{{na.name}}
								</div>
							</router-link>
						
						<transition name="slide-fade">
							<ul v-show="judge == na.id">
								<li v-for="con in navcontent[index].content" @click="linkto(na.id)">
									<router-link :to= 'con.vuelink'>
										{{con.name}}
									</router-link>
								</li>
							</ul>
						</transition>
					</li>
				</ul>
			</div>
		<!--<div class="header-nav">
			<div class="nav-logo">
				<img :src="logo"/>
			</div>
			<div class="nav-none">
				
			</div>
			
			<div class="nav-sys">
				<div class="sys-zone">
					<a href="http://oa.gd-sc.net:8080/obpm/">
					<span>
						<img src="../../static/img/user-enter.png"/>业务系统入口
					</span>
					</a>
				</div>
			</div>
		</div>-->
	</header>
</template>
<script>
	export default{
		name: 'vheader',
		data (){
			return {
					nav : [
						{id : 0, name : '首页' , linkto : '/'},
						{id : 1, name : '关于思程' , linkto : '/Aboutcom/' + 0},
						{id : 2, name : '业务中心' , linkto : '/Technology/' + 0},
						{id : 3, name : '解决方案' , linkto : '/Solve/'+ 0},
						{id : 4, name : '案例展示' , linkto : '/Case/'},
						{id : 5, name : '我们的产品' , linkto : '/Product/'+ 0},
						{id : 6, name : '服务平台' , linkto : '/Saltout/'},
					],
					navcontent : [
						{content : [{name : '技术领域' , vuelink : '/'},{name : '业务模式' , vuelink : '/'}]},
						{content : [{name : '公司简介' , vuelink : '/Aboutcom/' + 0},{name : '资质荣誉' , vuelink : '/Aboutcom/' + 3},{name : '组织框架' , vuelink : '/Aboutcom/' + 1},{name : '企业文化' , vuelink : '/Aboutcom/' + 2},{name : '新闻资讯' , vuelink : '/Aboutcom/' + 4}]},
						{content : [{name : '服务领域' , vuelink : '/Technology/' + 0},{name : '业务模式' , vuelink : '/Technology/' + 1},{name : '技术领域' , vuelink : '/Technology/' + 2}]},
						{content : [{
							name : '新零售' , vuelink : '/Solve/'+ 0},
							{name : '智慧旅游' , vuelink : '/Solve/'+ 1},
							{name : '智慧法院' , vuelink : '/Solve/'+ 2},
							{name : '智慧校园' , vuelink : '/Solve/'+ 5},
							{name : '智慧工厂' , vuelink : '/Solve/'+ 6},
							{name : '公共资源交易' , vuelink : '/Solve/'+ 3},
							{name : '律师行业业务' , vuelink : '/Solve/'+ 4},
							{name : '立体化社会防范' , vuelink : '/Solve/'+ 7}
						]},
						{content : [{name : '案例展示' , vuelink : '/'}]},
						{content : [
							{name : '环境监测系统' , vuelink : '/Product/'+ 0},
							{name : '企业招投标系统' , vuelink : '/Product/'+ 1},
							{name : '公共资源业务' , vuelink : '/Product/'+ 2},
							{name : '智慧旅游业务' , vuelink : '/Product/'+ 3},
							{name : '新零售业务系统' , vuelink : '/Product/'+ 4},
							{name : '律师行业系统' , vuelink : '/Product/'+ 5},
							{name : '通用OA业务系统' , vuelink : '/Product/'+ 6},
							{name : '智能综合指挥' , vuelink : '/Product/'+ 7},
						]},
						{content : [{name : '售后服务' , vuelink : '/Saltout'},{name : '诚聘英才' , vuelink : '/Zhaopin'},{name : '联系我们' , vuelink : '/Contactu'}]},
					],
					judge : -1,
					width : '100%',
					liwidth :'100%',
					logo : 'static/img/logo.png',
					backg : '#fff',
					color : '#fff',
					acli : 0 ,
					op : .1
			}
		},
		mounted(){
			this.getscro();
		},
		methods : {
			slide(index){
				if(index == 0 || index == 4 || index==5 || index==3){
					this.judge = -1
				}else{
					this.judge = index
					if(index == 1){
						this.width = '500%'
						this.liwidth = '20%'
					}else if(index == 2){
						this.width = '200%'
						this.liwidth = '50%'
					}else if(index == 3 || index == 5){
						this.width = '400%'
						this.liwidth = '25%'
					}else if(index == 6){
						this.width = '300%'
						this.liwidth = '33.3%'
					}
				}
			},
			out(){
				this.judge = -1
			},
			linkto(index){
				this.acli = index
				this.gotop()
			},
			gotop(){
				window.scrollTo(0,0)
			},
			getscro(){
				var that = this;
				$(document).scroll(function(){
            		var top = $(document).scrollTop();
            		if(top>150){
            			that.logo = 'static/img/logoit.png'
            			that.backg = '#0066ef'
            			that.color = '#fff'
            			that.op = 1
            		}else if(top == 0){
            			that.logo = 'static/img/logo.png'
            			that.backg = '#fff'
            			that.color = '#fff'
            			that.op = .1
            		}else if(top > 15 & top <= 150){
            			that.op = 1
            			that.logo = 'static/img/logo.png'
            			that.color = '#000'
            			that.backg = '#fff'
            		}
            	});
			},
		},
	}
</script>

<style>
	header{
		clear: both;
		width: 100%;
		margin: 0 auto;
		z-index: 20;
		top: 0;
		left: 0;
		position: relative;
	}
	.top-logo{
		position: absolute;
	    width: 20%;
	    display: inline-block;
	    clear: both;
	    float: left;
	    text-align: left;
	    left: 7vw;
	}
	.top-other{
		position: absolute;
	    width: 60%;
	    display: inline-block;
	    clear: both;
	    float: right;
	    text-align: right;
	    top: 1.3vw;
	    right: 9%;
	}
	.top-other img{
		position: relative;
		margin-right: 15px;
	}
	.top-logo img{
		position: relative;
		min-height: 45px;
		top: .5vw;
		
	}
	.header-o{
		height: 55px;
		width: 100%;
		display: inline-block;
		position: absolute;
	    z-index: 0;
	    left: 0;
	}
	.header-logo{
		position: relative;
		width: 100%;
		height: 90px;
		background: url(../../static/img/top_bg.gif) repeat-y;
		background-color: #d6d6d5;
	}
	.header-nav{
		position: relative;
		width: 85%;
		padding: 8px 0;
		margin: 0 auto;
		clear: both;
		height: 62px;
	}

	.nav-logo{
		position: relative;
		width: 10%;
		display: inline-block;
		text-align: left;
	}
	.nav-none{
		position: relative;
		width: 72%;
		display: inline-block;
	}
	.nav-logo img{
		height: 47px;
	}
	.nav-nav{
		width: 85%;
		position: absolute;
		margin: 0 auto;
		text-align: center;
		left: 9%;
		z-index: 20;
		height: 55px;
	}
	.nav-nav li{
		list-style: none;
		width: 12%;
		display: inline-block;
		color: #FFFFFF;
		font-size: 17px;
		z-index: 20;
		vertical-align: text-top;
		height: 55px;
		line-height: 55px;
		transition: all .5s
	}
	.nav-nav li a{
		text-decoration: none;
		color: #fff;
	}
	.nav-nav li:hover{
		background: #297be9;
		color: #FFF !important;
		font-weight: 700;
	}
	.nav-nav li:hover>.gogogo a{
		color: #FFF !important;
	}
	.nav-nav li li{
		display: block;
		transition: all .2s;
		height: 50px;
    	line-height: 50px;
    	vertical-align: middle;
    	font-weight: 100 ;
    	margin-top: -1px;
    	overflow: hidden; 
	    text-overflow: ellipsis;
	    white-space: nowrap;
	   	width: 100%;
	   	-moz-margin-start: 40px;
	   	background: #fff;
	}
	.nav-nav li li a{
		text-decoration: none;
		color: #007bc5;
		display: block;
		width: 100%;
		height: 100%;
	}
	.nav-nav li li:hover{
		background: #297be9;
		font-weight: 700;
	}
	.nav-nav li li:hover>a{
		color: #fff;
	}
	.nav-nav li.liactive{
		background: #297be9;
		color: #FFF !important;
		font-weight: 700;
	}
	.nav-nav li a.liaactive{
		color: #FFF !important;
	}
	.nav-nav ul{
	    -webkit-margin-before: 0em;
	    -webkit-margin-after: 0em;
	    -webkit-margin-start: 0px;
	    -webkit-margin-end: 0px;
	    -webkit-padding-start: 0px;
	    -moz-margin-start: 0;
	    -moz-margin-end: 0;
	}
	.nav-nav ul ul{
		-webkit-margin-before: 0em;
	    -webkit-margin-after: 0em;
		background: #236BC9;
		height: 50px;
    	line-height: 50px;
	}
	.nav-sys{
		width: 10%;
		position: relative;
		display: inline-block;
	}
	.sys-zone{
		position: relative;
		background: #0058cf;
		padding: 5px;
		width: 140px;
	}
	.sys-zone img{
		width: 20px;
		position: relative;
		margin-right: 7px;
		bottom: 2px;
	}
	.sys-zone span{
		color: #FFFFFF;
	}
	.slide-fade-enter-active {
	  transition: all .0s ease;
	}
	.slide-fade-leave-active {
	  transition: all .01s cubic-bezier(1.0, 0.5, 0.8, 1.0);
	}
	.slide-fade-enter, .slide-fade-leave-to
	/* .slide-fade-leave-active for below version 2.1.8 */ {
	  transform: translateX(10px);
	  opacity: 0;
	}
	.header-logonav{
		position: relative;
		width: 85%;
		margin: 0 auto;
	}
</style>




// WEBPACK FOOTER //
// src/components/header.vue